/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getSignalsListCached } from '../../../../../stores/signals-main/signals/getters';
import { saveSignalsListLocation } from '../helpers/save-and-send-location';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
  },
}));

const CellAlertNo = ({ row = {} }) => {
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;
  const history = useHistory();

  const signalCount = useSelector((state) => {
    const { signalCount = 0 } =
      getSignalsListCached(state).find((d) => d._id === _id) || {};

    return signalCount;
  });

  const handleRedirectToEdit = () => {
    saveSignalsListLocation();

    history.push(`/signals/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToEdit}>
      {signalCount}
    </div>
  );
};

export default CellAlertNo;
